module.exports = __webpack_public_path__ + "static/media/Lie in the Sun - No Lead Vocals.ddd79360.jpg";